<template>
    <div class="col s12 no-padding full-height-percent">
      <div class="row login-header app-body-height">
        <div class="col s12 left-align">
          <h5 class="blue-color">{{ $t('views.login.loginscreenheader') }}</h5>
          <form>
            <div class="row">
              <div class="input-field col s12 no-margin-bottom">
                <input
                  autocomplete="on"
                  @keyup.enter="login()"
                  id="email"
                  type="text"
                  class="validate"
                  v-model="username">
                <label ref="email" for="email">{{ $t('views.login.email') }}</label>
                <span
                  class="helper-text"
                  data-error="Email address format is incorrect"
                />
              </div>
              <div class="input-field col s12 no-margin">
                <input
                  autocomplete="on"
                  @keyup.enter="login()"
                  id="password"
                  type="password"
                  v-model="password"
                  class="validate">
                <label for="password" ref="password">{{ $t('views.login.password') }}</label>
              </div>
              <div
                v-if="error"
                class="col s12 login-error helper-text">
                <div>{{ $t(error) }}</div>&nbsp;&nbsp;&nbsp;
                <i class="material-icons">warning</i>
              </div>
            </div>
          </form>
        </div>
        <div class="col s12 valign-wrapper">
          <div class="col s6 left-align">
            <div class="row s12 no-margin-bottom">
              <a
                @click="login()"
                class="waves-effect waves-light btn signin-button">{{ $t('views.login.login') }}</a>
            </div>
          </div>
          <div class="col s6 right-align">
            <div class="row s12 no-margin-bottom">

              <div class="dropdown-width language-dropdown">
                <a
                  class="valign-wrapper dropdown-trigger grey-color cursor-hand"
                  data-target='ddOperationalMode'>
                  <img
                    class="flag-size"
                    :src="require('../../assets/country/' + locale + '.png')">
                <i class="small material-icons">arrow_drop_down</i></a>

                <!-- Dropdown language -->
                <!-- LINK TO FLAGS: https://www.iconfinder.com/iconsets/flags_gosquared
                (free for commercial use) -->
                <ul
                  id='ddOperationalMode'
                  class='dropdown-content' >
                  <li
                    v-for="lang in locales"
                    :key="lang">
                    <a
                      class="grey-color no-padding center-align cursor-hand"
                      @click="changeLanguage(lang)" >
                      <img :src="require('../../assets/country/' + lang + '.png')">
                    </a>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        <div class="col s12 left-align forgot-password">
          <router-link
            class="no-margin grey-color"
            to="forgotpassword"><p>{{ $t('views.login.forgotpassword') }}</p></router-link>
        </div>
      </div>
      <div class="row app-footer-height app-footer-margins">
        <div class="col s6 left-align no-padding">
          <router-link
            class="no-margin blue-color"
            to="support">{{ $t('views.login.support') }}</router-link>
        </div>
        <div class="col s6 right-align no-padding">
          <p class="no-margin grey-color">{{ this.$parent.versionNumber }}</p>
        </div>
      </div>
    </div>
</template>

<script>
import M from 'materialize-css'

import AuthService from '../../services/AuthService.js'
import router from '../../router'
import Translation from '../../i18n/Translation.js'
import LanguageService from '../../services/api/LanguageService'

export default {
  data () {
    return {
      username: undefined,
      password: undefined,

      // The error to display below the password field on the login screen
      error: undefined,

      // Translation
      locales: [],
      locale: Translation.getCurrentLanguage()
    }
  },
  methods: {
    changeLanguage (newValue) {
      Translation.setLanguage(newValue).then((language) => {
        this.locale = language
      })
    },
    login: function () {
      this.error = ''
      AuthService.login({
        CultureCode: 'nl-NL',
        Username: this.username,
        Password: this.password
      }).then(() => {
        router.push('/login/loaddata')
      }).catch(e => {
        if (e.response && e.response.status === 400) {
          this.error = 'views.login.invalid'
        } else if (e.response && e.response.status === 401) {
          this.error = 'views.login.invalid'
        } else if (e.response && e.response.status === 402) {
          this.$parent.$parent.$router.push('/login/disclaimer')
        } else {
          this.error = e + ''
        }
      })
    }
  },
  beforeMount () {
    LanguageService.getLanguages()
      .then(response => {
        response.data.forEach(element => {
          this.locales.push(element.Translation)
        })
      })
      .catch(e => {
        console.log(e)
      })
    if (!this.$parent.preventLogin) {
      router.push('/login/loginscreen')
    } else {
      router.push('/login/error')
    }
  },
  mounted: function () {
    this.changeLanguage(this.locale)
    var elem = document.querySelector('.dropdown-trigger')
    var ddcontainelem = document.querySelector('.dropdown-width')
    var options = {
      container: ddcontainelem,
      constrainWidth: false
    }
    M.Dropdown.init(elem, options)
  }
}
</script>

<style scoped>
  .flag-size {
    width: 32px;
  }

  .forgot-password {
     font-size: 14px;
  }

  .login-error {
    font-size: 12px;
    color:red;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .login-header {
    color: #56CCF2;
    line-height: 28px;
    font-size: 20px;
    padding-top: 147px;
    padding-left: 53px;
    padding-right: 49px;
  }

  .language-dropdown {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.38);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border:none;
    outline:none;
  }

  /* CUSTOM INPUT FIELD COLORS */
 /* label color */
   .input-field label {
      color: rgba(0, 0, 0, 0.38);
   }
   /* label focus color */
   .input-field input[type=email]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }
    .input-field input[type=text]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }
    .input-field input[type=password]:focus + label {
     color: rgba(0, 0, 0, 0.38);
   }

   /* label underline focus color */
   .input-field input[type=email]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
      /* label underline focus color */
   .input-field input[type=text]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
  .input-field input[type=password]:focus {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }

   /* valid color */
   .input-field input[type=email].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
    .input-field input[type=text].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }
   .input-field input[type=password].valid {
     border-bottom: 1px solid #56CCF2;
     box-shadow: 0 1px 0 0 #56CCF2;
   }

   /* icon prefix focus color */
   .input-field .prefix.active {
     color: #000;
   }
</style>



// WEBPACK FOOTER //
// src/pages/login/_LoginScreen.vue